import Vue from 'vue'
import Router from 'vue-router'
import index from '../index'
import rule from '../rule'
import rule_1 from '../rule_1'
import share from '../share'
import join from '../join'
import success from '../success'
import defaults from '../defaults'
import course from '../course'
import shareCourse from '../shareCourse'
import summit from '../summit'
import shareSummit from '../shareSummit'
import community from '../community'
import shareCommunity from '../shareCommunity'
import payAgreement from '../payAgreement'
import couponRules from '../couponRules'
import rechargeGuide from '../rechargeGuide'



Vue.use(Router)

export default new Router({
  // mode: "history",
  routes: [{
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/rule_1',
      name: 'rule_1',
      component: rule_1
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/defaults',
      name: 'defaults',
      component: defaults
    },
    {
      path: '/share/:code',
      name: 'share',
      component: share
    },
    {
      path: '/course',
      name: 'course',
      component: course
    }, {
      path: '/shareCourse',
      name: 'shareCourse',
      component: shareCourse
    }, {
      path: '/summit',
      name: 'summit',
      component: summit
    }, {
      path: '/shareSummit',
      name: 'shareSummit',
      component: shareSummit
    }, {
      path: '/community',
      name: 'community',
      component: community
    }, {
      path: '/shareCommunity',
      name: 'shareCommunity',
      component: shareCommunity
    }, {
      path: '/payAgreement',
      name: 'payAgreement',
      component: payAgreement
    }, {
      path: '/couponRules',
      name: 'couponRules',
      component: couponRules
    }, {
      path: '/rechargeGuide',
      name: 'rechargeGuide',
      component: rechargeGuide
    },
  ]
})



// WEBPACK FOOTER //
// ./src/pages/member-share/router/index.js